import React from "react";
import CarouselCalendar from "../../../../calendar/carouselCalendar";

const IndividualWeekSettings = () => <CarouselCalendar isSettings />;

export default React.memo(IndividualWeekSettings);
